var map = {
	"./CampignStatistics.svg": 90777,
	"./Percent.svg": 62334,
	"./PerformanceCampign.svg": 10454,
	"./access_purple.svg": 94485,
	"./add.svg": 68122,
	"./add_purple.svg": 13376,
	"./app.svg": 12800,
	"./application.svg": 25097,
	"./approve_green.svg": 26755,
	"./approve_white.svg": 49082,
	"./arrow-bas.svg": 11511,
	"./arrow-down.svg": 85011,
	"./arrow-left.svg": 26634,
	"./arrow-up.svg": 61451,
	"./awareness.svg": 22190,
	"./bookmark.svg": 27447,
	"./brands.svg": 96491,
	"./brief_sidebar.svg": 5606,
	"./brief_sidebar_black.svg": 35991,
	"./brief_white.svg": 80018,
	"./brief_white_timeline.svg": 48773,
	"./calculate.svg": 91029,
	"./calendar.svg": 64674,
	"./camera.svg": 72360,
	"./camp.svg": 77654,
	"./change.svg": 7634,
	"./chat.svg": 12847,
	"./clients.svg": 93039,
	"./clock.svg": 23826,
	"./close_icon.svg": 37991,
	"./collaborations.svg": 45740,
	"./colored-objectives/app-install.svg": 94046,
	"./colored-objectives/brand-awareness.svg": 62795,
	"./colored-objectives/customer-loyalty.svg": 49045,
	"./colored-objectives/engagement.svg": 26882,
	"./colored-objectives/lead-generation.svg": 12035,
	"./colored-objectives/product-launch.svg": 80442,
	"./colored-objectives/purchases-sales.svg": 47872,
	"./colored-objectives/store-opening.svg": 6609,
	"./colored-objectives/traffic.svg": 65976,
	"./comment-red.svg": 26933,
	"./comment-white.svg": 10063,
	"./comments.svg": 24322,
	"./community.svg": 25950,
	"./contact.svg": 61669,
	"./contact_support.svg": 81015,
	"./content.svg": 26287,
	"./content_black.svg": 47091,
	"./content_white.svg": 11751,
	"./content_white_timeline.svg": 16857,
	"./contract_sidebar.svg": 19535,
	"./contract_sidebar_black.svg": 94129,
	"./contract_white.svg": 98277,
	"./contract_white_timeline.svg": 73037,
	"./customer.svg": 49776,
	"./debrief.svg": 49090,
	"./delete.svg": 23776,
	"./description.svg": 57909,
	"./discover.svg": 88917,
	"./dollar-gray.svg": 75945,
	"./edit.svg": 59945,
	"./engagement-rate-gray.svg": 22451,
	"./engagement.svg": 83319,
	"./event-coverage.svg": 14792,
	"./eye.svg": 14171,
	"./favorite.svg": 40603,
	"./female.svg": 52764,
	"./filter-icon.svg": 17930,
	"./fixed-price.svg": 76840,
	"./followers-count-gray.svg": 35546,
	"./followers.svg": 32087,
	"./gender-gray.svg": 55954,
	"./globe-black.svg": 17249,
	"./globe-gray.svg": 65418,
	"./globe-purple.svg": 41718,
	"./go-to.svg": 47809,
	"./grid-view.svg": 67773,
	"./heart-white.svg": 96949,
	"./heart.svg": 58371,
	"./heart_black.svg": 786,
	"./heart_red.svg": 61794,
	"./home.svg": 9182,
	"./hour-glass-gray.svg": 32230,
	"./inbox.svg": 2828,
	"./info.svg": 59519,
	"./info_purple.svg": 10940,
	"./instagram.svg": 97448,
	"./install_black.svg": 94784,
	"./install_blue.svg": 11209,
	"./invitation_white.svg": 10089,
	"./invitations.svg": 1075,
	"./launch.svg": 92602,
	"./lead.svg": 7131,
	"./list-view.svg": 48210,
	"./location-gray.svg": 14756,
	"./lock.svg": 32193,
	"./logout.svg": 27624,
	"./male.svg": 17640,
	"./mark_as_seen_black.svg": 35586,
	"./menu_view_white.svg": 72695,
	"./money-gray.svg": 31573,
	"./notification_bell.svg": 55209,
	"./notifications-icons/application.svg": 14314,
	"./notifications-icons/application_icon.svg": 67866,
	"./notifications-icons/brief_icon.svg": 8251,
	"./notifications-icons/campaign_icon.svg": 54459,
	"./notifications-icons/collaboraton_icon.svg": 35898,
	"./notifications-icons/content_approval_icon.svg": 30931,
	"./notifications-icons/content_review_icon.svg": 85548,
	"./notifications-icons/contract_icon.svg": 44448,
	"./notifications-icons/invitation_icon.svg": 41005,
	"./notifications-icons/performance_icon.svg": 7652,
	"./notifications-icons/planning_icon.svg": 81928,
	"./notifications-icons/quote_icon.svg": 46435,
	"./opportunities.svg": 80672,
	"./order_gray.svg": 88470,
	"./order_purple.svg": 95085,
	"./passage-magasin.svg": 84964,
	"./pen-blue.svg": 69120,
	"./pen-white.svg": 88979,
	"./pencil-gray.svg": 59128,
	"./pencil-purple.svg": 7659,
	"./performance.svg": 88910,
	"./performance_black.svg": 40716,
	"./performance_white.svg": 83104,
	"./performance_white_timeline.svg": 85327,
	"./phone.svg": 63980,
	"./pictures.svg": 25841,
	"./pin.svg": 67587,
	"./planning.svg": 59827,
	"./planning_black.svg": 65212,
	"./planning_white.svg": 16927,
	"./planning_white_timeline.svg": 98347,
	"./plus.svg": 74132,
	"./plus_gray.svg": 24152,
	"./plus_white.svg": 85109,
	"./post-image-gray.svg": 83831,
	"./post-reel-gray.svg": 97468,
	"./post-reel.svg": 20809,
	"./production-reel.svg": 76045,
	"./profile.svg": 50808,
	"./promotion.svg": 27601,
	"./quit.svg": 35657,
	"./quote.svg": 36931,
	"./quote_black.svg": 10474,
	"./quote_white.svg": 89451,
	"./quote_white_timeline.svg": 47037,
	"./remove_screenshot.svg": 59845,
	"./return.svg": 7095,
	"./sales.svg": 20317,
	"./search-bar.svg": 98668,
	"./search.svg": 96962,
	"./search_icon.svg": 22274,
	"./service-exchange-gray.svg": 33908,
	"./settings.svg": 69530,
	"./share.svg": 16641,
	"./short-lists.svg": 75847,
	"./show.svg": 69614,
	"./sort-filter.svg": 39717,
	"./stats.svg": 19925,
	"./store.svg": 75483,
	"./story-gray.svg": 47368,
	"./story-set.svg": 18819,
	"./story.svg": 14375,
	"./story_black.svg": 69464,
	"./three_black_points_h.svg": 96016,
	"./three_black_points_v.svg": 4752,
	"./thumb-like-green.svg": 52775,
	"./thumb-like-white.svg": 13670,
	"./thumb-like.svg": 13610,
	"./tiktok-square.svg": 96196,
	"./tiktok-video.svg": 96177,
	"./tiktok.svg": 41701,
	"./time.svg": 99698,
	"./toggle-menu.svg": 18090,
	"./track-performance.svg": 67530,
	"./traffic.svg": 81985,
	"./trash-gray.svg": 24203,
	"./trash-pink.svg": 53437,
	"./trash-pinkish.svg": 77440,
	"./trashcan_black.svg": 13589,
	"./unboxing.svg": 93633,
	"./video-identifier.svg": 53633,
	"./video.svg": 17452,
	"./video_black.svg": 29185,
	"./view-stories_performance.svg": 49185,
	"./view-white.svg": 20695,
	"./views.svg": 12737,
	"./zip.svg": 11546
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20866;